import { useAppDisplayModeContext } from '@archipro-design/aria';
import LatestArticlesMobile from '@modules/articles/component/latest-articles/LatestArticles.mobile';
import type { TileProps } from '../../type';
import LatestArticlesDesktop from './LatestArticles.desktop';

export interface LatestArticlesProps {
    title: string;
    latestArticles: TileProps[];
    loadMoreLink?: string;
    useFilmsLayout?: boolean;
}

const LatestArticles = ({
    latestArticles,
    title,
    loadMoreLink,
    useFilmsLayout,
}: LatestArticlesProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <>
            {isMobile ? (
                <LatestArticlesMobile
                    title={title}
                    latestArticles={latestArticles}
                    loadMoreLink={loadMoreLink}
                    useFilmsLayout={useFilmsLayout}
                    showCategory={true}
                />
            ) : (
                <LatestArticlesDesktop
                    title={title}
                    latestArticles={latestArticles}
                    loadMoreLink={loadMoreLink}
                    useFilmsLayout={useFilmsLayout}
                    showCategory={true}
                />
            )}
        </>
    );
};

export default LatestArticles;
